module.exports = __webpack_public_path__ + "static/media/pen.d7da1e6d.svg";